module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_4.0777f635.png";